export const getCookie = (name) => {
  const cookies = document.cookie;
  const target = cookies.split(';').filter((res) => res.includes(name));
  if (target.length) {
    return target[0].split('=').pop();
  }
  return null;
};
